let loggingEnabled = true;

// NOTE: 'type' and 'key' may be null/falsy
const logstr = (type, key, msg) =>
  [type ? `<WGL:${type}> ` : '<WGL> ', key ? `["${key}"] ` : '', msg].join('');

class WGLLog {
  static enable() {
    loggingEnabled = true;
  }

  static disable() {
    loggingEnabled = false;
  }

  static info(type, key, msg) {
    if (!loggingEnabled) {
      return;
    }
    console.log(logstr(type, key, msg));
  }

  static error(type, key, msg) {
    if (!loggingEnabled) {
      return;
    }
    console.error(logstr(type, key, msg));
  }

  static errorRaw(msg) {
    console.error(msg);
  }
}

export default WGLLog;
